module.exports = __webpack_public_path__ + "img/status.c1d33d80.svg";